import {
  GET_SENSOR_CHART_REQUEST,
  GET_SENSOR_CHART_SUCCESS,
  GET_SENSOR_CHART_FAILURE,
  GET_SENSOR_FULL_CHART_REQUEST,
  GET_SENSOR_FULL_CHART_SUCCESS,
  GET_SENSOR_FULL_CHART_FAILURE,
  GET_SENSOR_METRICS_REQUEST,
  GET_SENSOR_METRICS_SUCCESS,
  GET_SENSOR_METRICS_FAILURE,
  RESET_SENSOR_DETAILS,
} from './SensorDetails.constant';
import { GetChartResponse } from './SensorDetails.type';

export const getSensorDetailChartRequest = (payload: {
  sensor_id: number;
  measurement_id: number;
  query?: string;
}) => ({
  type: GET_SENSOR_CHART_REQUEST,
  payload,
});

export const getSensorDetailChartSuccess = (payload: GetChartResponse) => ({
  type: GET_SENSOR_CHART_SUCCESS,
  payload,
});

export const getSensorDetailChartFailure = (payload: unknown) => ({
  type: GET_SENSOR_CHART_FAILURE,
  payload,
});

export const getSensorDetailFullChartRequest = (payload: {
  sensor_id: number;
  query?: string;
}) => ({
  type: GET_SENSOR_FULL_CHART_REQUEST,
  payload,
});

export const getSensorDetailFullChartSuccess = (payload: unknown) => ({
  type: GET_SENSOR_FULL_CHART_SUCCESS,
  payload,
});

export const getSensorDetailFullChartFailure = (payload: unknown) => ({
  type: GET_SENSOR_FULL_CHART_FAILURE,
  payload,
});

export const getSensorMetricsRequest = (payload: {
  sensor_id: number;
  query?: string;
}) => ({
  type: GET_SENSOR_METRICS_REQUEST,
  payload,
});

export const getSensorMetricsSuccess = (payload: unknown) => ({
  type: GET_SENSOR_METRICS_SUCCESS,
  payload,
});

export const getSensorMetricsFailure = (payload: unknown) => ({
  type: GET_SENSOR_METRICS_FAILURE,
  payload,
});

export const resetSensorDetails = () => ({
  type: RESET_SENSOR_DETAILS,
});
